import { createElement } from 'rax';
import Calendar from '../../calendar';
import EmbedDatePicker from '../embed-picker/date-picker';
import EmbedDateTimePicker from '../embed-picker/time-picker';
import EmbedMinutePicker from '../embed-picker/minute-picker';
import { DEFAULT_FORMAT } from '../../time-picker/utils';
import { withTime } from '../utils';
import BasePicker from './base-picker';
export default class DatePicker extends BasePicker {
    get timeFormat() {
        const { showTime } = this.props;
        return typeof showTime === 'object' && showTime.format ? showTime.format : DEFAULT_FORMAT;
    }
    get format() {
        const { showTime } = this.props;
        const format = this.props.format || 'YYYY-MM-DD';
        return showTime && !withTime(format) ? `${format} ${this.timeFormat}` : format;
    }
    renderPicker() {
        const { showTime, validRange, mode, dateCellRender } = this.props;
        if (mode === 'picker') {
            let embedPicker = null;
            if (showTime) {
                const { format } = showTime;
                if (format === 'HH:mm') {
                    embedPicker = (<EmbedMinutePicker value={this.state.pickerValue} disabledDate={this.props.disabledDate} validRange={validRange} onChange={this.handleChange}/>);
                }
                else {
                    embedPicker = (<EmbedDateTimePicker value={this.state.pickerValue} disabledDate={this.props.disabledDate} validRange={validRange} onChange={this.handleChange}/>);
                }
            }
            else {
                embedPicker = (<EmbedDatePicker value={this.state.pickerValue} disabledDate={this.props.disabledDate} validRange={validRange} onChange={this.handleChange}/>);
            }
            return embedPicker;
        }
        if (showTime) {
            if (!validRange) {
                throw new Error('DatePicker with showTime must have validRange');
            }
            const { format } = showTime;
            return (<Calendar ref={this.calendarRef} shape="panel" mode="month" enableYearPicker enableTimePicker timeFormat={format} dateCellRender={dateCellRender} value={this.state.pickerValue} disabledDate={this.props.disabledDate} validRange={validRange} onSelect={this.handleChange} onYearPickerVisibleChange={this.handleYearPickerVisibleChange}/>);
        }
        else {
            return (<Calendar ref={this.calendarRef} shape="panel" mode="month" enableYearPicker value={this.state.pickerValue} dateCellRender={dateCellRender} disabledDate={this.props.disabledDate} validRange={this.props.validRange} onSelect={this.handleChange} onYearPickerVisibleChange={this.handleYearPickerVisibleChange}/>);
        }
    }
    getDefaultFormat() {
        return '';
    }
}
